import { html } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

import { KlarnaBadge, KlarnaBadgeBlackBackground } from '../../assets/logos'
import getLanguage from '../helpers/getLanguage/getLanguage'
import styles from './style.scss'

export default function homePagePromotionTall({
  textTitle = '',
  textSubtitle = '',
  locale = '',
  theme = '',
  onLearnMoreClick,
}: {
  textTitle?: string
  textSubtitle?: string
  locale?: string
  theme?: string
  onLearnMoreClick: (event: MouseEvent) => void
}) {
  const language = getLanguage(locale)

  return html`
    <style>
      ${styles}
    </style>
    <div
      data-testid="${textTitle ? 'home-page-promotion-tall' : ''}"
      class="container ${theme}"
      @click=${onLearnMoreClick}
    >
      <div class="content-container">
        <div class="content">
          <div class="heading-${language.toLowerCase()} heading item">
            <div>${html`${unsafeHTML(textTitle)}`}</div>
          </div>
          <div class="sub-text-${language.toLowerCase()} sub-text item">
            <div>${html`${unsafeHTML(textSubtitle)}`}</div>
          </div>
        </div>
        <div class="logo-container item">
          <div class="badge" part="osm-badge-container">
            ${theme === 'dark'
              ? unsafeHTML(KlarnaBadge())
              : KlarnaBadgeBlackBackground({ classParams: 'badge-black' })}
          </div>
        </div>
      </div>
    </div>
  `
}
